module.exports = __webpack_public_path__ + "eu.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/eu.svg
// module id = 1157
// module chunks = 0